<template lang="pug">
  .woocommerce
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .contain-layout(v-else)

      .main-layout(v-if="!action")
        v-container(style="max-width:600px").px-7
          v-layout.my-4.mx-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/woo-logo.png')" style="width:140px" contain)
          v-btn.mt-8.button-AA-medium.white--text.info500(block depressed @click="openSetup") {{ $t('connect_website') }}
            v-icon(v-if="ecommerce.id" right color="white") mdi-check-circle-outline
          v-btn.mt-4.button-AA-medium.white--text.info500(depressed v-if="ecommerce.id" block outlined @click="openSettings") {{ $t('settings') }}
            //- v-icon(v-if="ecommerce.id" right color="green lighten-1") mdi-check-circle
          v-btn.mt-4.button-AA-medium.white--text.info500( depressed v-if="ecommerce.id" block outlined @click="openSyncProducts") {{ $t('sync_products') }}
      .action-layout(v-else)
        v-layout.mb-14.mt-2.mx-4
          div.mr-4
            v-icon(left color="black" :size="20" @click="action = null") mdi-arrow-left
          div.h6.mt-1 {{ $t('woocommerce_setup') }}
        setup-woo-commerce(v-if="action == 'setup-account'" :company="company" :ecommerce="ecommerce")
        settings-woo-commerce(v-if="action == 'settings'" :company="company" :ecommerce.sync="ecommerce" @finish="action = null")
        SyncWoocommerceProducts(v-if="action == 'sync-products'" :ecommerce.sync="ecommerce")

</template>

<script>
import SetupWooCommerce from '@/views/admin/settings/SetupWooCommerce.vue'
import SettingsWooCommerce from '@/views/admin/settings/SettingsWooCommerce.vue'
import SyncWoocommerceProducts from '@/views/admin/settings/SyncWoocommerceProducts.vue'
import { mapActions } from 'vuex'

export default {
  name: 'WooCommerce',
  components: { SetupWooCommerce, SettingsWooCommerce, SyncWoocommerceProducts },
  props: ['company'],
  data: () => ({
    isFetching: true,
    ecommerce: {},
    action: null
  }),
  mounted () {
    this.fetchEcommerce()
    if (this.$route.hash === '#setup') {
      this.action = 'setup-account'
    } else if (this.$route.hash === '#settings') {
      this.action = 'settings'
    } else if (this.$route.hash === '#syncproducts') {
      this.action = 'sync-products'
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    gotoActivate () {
      this.$router.push('/admin/settings')
    },
    fetchEcommerce () {
      this.$axios.get(`/ecommerce/woocommerce/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length > 0) {
          this.ecommerce = {...response.data.results[0]}
        }
        this.isFetching = false
      })
      .catch(() => {})
    },
    openSetup () {
      
      this.action = 'setup-account'
      let route = { ...this.$route }
      route.hash = '#setup'
      this.$router.replace(route)
    },
    openSettings () {
      this.action = 'settings'
      let route = { ...this.$route }
      route.hash = '#settings'
      this.$router.replace(route)
    },
    openSyncProducts () {
      this.action = 'sync-products'
      let route = { ...this.$route }
      route.hash = '#syncproducts'
      this.$router.replace(route)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "woocommerce_setup": "WooCommerce Setup"
  },
  "id": {
     "woocommerce_setup": "Pengaturan WooCommerce"
  }
}
</i18n>
